import { render, staticRenderFns } from "./ModalGroupTypeProductEdit.vue?vue&type=template&id=5869269e&scoped=true"
import script from "./ModalGroupTypeProductEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupTypeProductEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupTypeProductEdit.vue?vue&type=style&index=0&id=5869269e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869269e",
  null
  
)

export default component.exports